import React from 'react';
import { motion } from 'framer-motion';
import { Gift, CheckCircle } from 'lucide-react';
const bonuses = [{
  title: '52 READY-TO-USE WARM-UPS',
  image: 'https://cdn.magicpatterns.com/uploads/mdJNtujgbh7HECL9P9xqAE/bono_1_(7).webp',
  lines: ['52 complete football warm-ups.', 'One for every week of the year.']
}, {
  title: '100 FOOTBALL GAMES COLLECTION',
  image: 'https://cdn.magicpatterns.com/uploads/4jmV5U4usEsbto9cRdHdkH/bono_2_(7).webp',
  lines: ['100 engaging football games ready to use.', 'Fun. Competition. Development.']
}, {
  title: 'EMERGENCY TRAINING PACK',
  image: 'https://cdn.magicpatterns.com/uploads/4nsbwtRXJs8aLhk7KAEN2h/bono_3_(6).webp',
  lines: ['30 instant sessions for:', 'Rainy Days', 'Low Attendance', 'Indoor Training', 'Small Spaces']
}, {
  title: 'FOOTBALL COACH COMMANDS HANDBOOK',
  image: 'https://cdn.magicpatterns.com/uploads/8MwVJcEgnsQYQgBLpFvvT8/bono_4_(7).webp',
  lines: ['100+ coaching commands for training and matchday.', 'Know what to say.', 'Know when to say it.']
}, {
  title: 'PLAYER EVALUATION SYSTEM',
  image: 'https://cdn.magicpatterns.com/uploads/ngo745bUX1HXpQ8HtFhavW/bono_5_(7).webp',
  lines: ['Professional player assessment tools.', 'Track progress. Create reports. Build development plans.']
}];
export function Bonuses() {
  return <section className="py-24 bg-navy-900 relative border-y border-navy-800" data-id="element-13">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-5 pointer-events-none" data-id="element-14"></div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-15">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-16">
          <motion.div initial={{
          opacity: 0,
          scale: 0.9
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gold-500/20 text-gold-500 mb-6" data-id="element-17">
            <Gift className="w-8 h-8" data-id="element-18" />
          </motion.div>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="font-anton text-4xl md:text-6xl text-white uppercase tracking-wide mb-6" data-id="element-19">
            5 BONUSES INCLUDED
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-xl text-gray-300" data-id="element-20">
            And you'll also receive 5 premium bonuses.
            <br data-id="element-21" />
            Exclusive coaching resources that will transform your coaching
            workflow —{' '}
            <span className="text-green-400 font-bold" data-id="element-22">
              included FREE today.
            </span>
          </motion.p>
        </div>

        <div className="max-w-4xl mx-auto space-y-6" data-id="element-23">
          {bonuses.map((bonus, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-navy-950 border border-navy-700 rounded-xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center relative overflow-hidden" data-id="element-24">
              <div className="absolute left-0 top-0 bottom-0 w-2 bg-gradient-to-b from-gold-400 to-gold-600" data-id="element-25"></div>

              <div className="flex-shrink-0 w-full md:w-44 lg:w-52 relative group" data-id="element-26">
                <div className="absolute -inset-2 bg-gold-500/10 blur-xl rounded-lg opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-27"></div>
                <img src={bonus.image} alt={`Bonus ${index + 1} — ${bonus.title}`} className="relative w-full h-auto rounded-lg shadow-2xl border border-navy-700/50" data-id="element-28" />
                <div className="absolute top-2 left-2 bg-gold-500 text-navy-950 font-anton text-sm px-2.5 py-1 rounded-md shadow-lg" data-id="element-29">
                  #{index + 1}
                </div>
              </div>

              <div className="flex-grow" data-id="element-30">
                <div className="text-gold-500 font-oswald text-sm tracking-widest mb-1" data-id="element-31">
                  BONUS #{index + 1}
                </div>
                <h3 className="font-oswald text-2xl text-white uppercase tracking-wide mb-4" data-id="element-32">
                  {bonus.title}
                </h3>
                <ul className="space-y-2" data-id="element-33">
                  {bonus.lines.map((line, i) => <li key={i} className="flex items-start gap-2 text-gray-400" data-id="element-34">
                      <CheckCircle className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-35" />
                      <span data-id="element-36">{line}</span>
                    </li>)}
                </ul>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="mt-16 text-center bg-navy-800/50 border border-navy-700 rounded-xl p-8 max-w-3xl mx-auto" data-id="element-37">
          <h4 className="font-oswald text-2xl text-white uppercase tracking-widest mb-2" data-id="element-38">
            Everything Included In
          </h4>
          <h3 className="font-anton text-3xl md:text-4xl text-gold-500 uppercase tracking-wide mb-4" data-id="element-39">
            FOOTBALL READY: SYSTEM 365
          </h3>
          <p className="text-green-400 font-bold text-lg" data-id="element-40">
            All 5 bonuses are included FREE with your purchase today.
          </p>
        </motion.div>
      </div>
    </section>;
}